/* ICI HOLO v1 — reveal al hacer scroll + brillo holográfico que sigue el cursor. Sin dependencias. */
(function () {
  var root = document.querySelectorAll('.icx [data-r]');
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!('IntersectionObserver' in window) || calm) {
    root.forEach(function (e) { e.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    root.forEach(function (e) { io.observe(e); });
  }
  if (calm) return;
  document.querySelectorAll('.icx-holo').forEach(function (el) {
    var t = false;
    el.addEventListener('pointermove', function (ev) {
      if (t) return; t = true;
      requestAnimationFrame(function () {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--mx', (ev.clientX - r.left) + 'px');
        el.style.setProperty('--my', (ev.clientY - r.top) + 'px');
        t = false;
      });
    }, { passive: true });
  });
})();
